import _Object$keys from "@babel/runtime-corejs3/core-js-stable/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor";
import _forEachInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/for-each";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js-stable/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js-stable/object/define-property";
import _toConsumableArray from "@babel/runtime-corejs3/helpers/toConsumableArray";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _findInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/find";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/filter";
import _concatInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/concat";
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/map";

function ownKeys(object, enumerableOnly) { var keys = _Object$keys(object); if (_Object$getOwnPropertySymbols) { var symbols = _Object$getOwnPropertySymbols(object); if (enumerableOnly) { symbols = _filterInstanceProperty(symbols).call(symbols, function (sym) { return _Object$getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { var _context3; _forEachInstanceProperty(_context3 = ownKeys(Object(source), true)).call(_context3, function (key) { _defineProperty(target, key, source[key]); }); } else if (_Object$getOwnPropertyDescriptors) { _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source)); } else { var _context4; _forEachInstanceProperty(_context4 = ownKeys(Object(source))).call(_context4, function (key) { _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { useCallback } from 'react';
import { useCombobox } from 'downshift';
import { createFakeEvent } from '../utils';
import { defaultFreeformItem } from '../utils/defaults';
export function useStateReactors(_ref) {
  var itemMap = _ref.itemMap,
      multi = _ref.multi,
      items = _ref.items,
      initialSelectedItems = _ref.initialSelectedItems,
      getItemId = _ref.getItemId,
      itemToString = _ref.itemToString,
      stateReducer = _ref.stateReducer,
      onStateChange = _ref.onStateChange,
      onChange = _ref.onChange,
      onBlur = _ref.onBlur,
      scrollToIndex = _ref.scrollToIndex,
      setFilterInputValue = _ref.setFilterInputValue,
      setSelectedItems = _ref.setSelectedItems;
  var numItems = items.length;
  return {
    stateReducer: useCallback(function (state, helpers) {
      var isOpen = state.isOpen,
          inputValue = state.inputValue,
          highlightedIndex = state.highlightedIndex,
          selectedItems = state.selectedItems;
      var type = helpers.type,
          changes = helpers.changes;
      var newSelectedItem = changes.selectedItem;

      var newChanges = _objectSpread(_objectSpread({}, changes), {}, {
        // Adding some custom state here because otherwise
        // the `onStateChange` function doesn't run when
        // re-selecting the same item, and therefore
        // we can't remove that item from our selected items
        selectedItems: selectedItems !== null && selectedItems !== void 0 ? selectedItems : initialSelectedItems
      }); // Never select the freeform item


      if (newSelectedItem === defaultFreeformItem) {
        return state;
      }

      switch (type) {
        case useCombobox.stateChangeTypes.ItemClick:
        case useCombobox.stateChangeTypes.InputKeyDownEnter:
        case useCombobox.stateChangeTypes.FunctionSelectItem:
        case useCombobox.stateChangeTypes.ControlledPropUpdatedSelectedItem:
          if (newSelectedItem) {
            if (multi) {
              var newSelectedItems = newChanges.selectedItems; // Remove the re-selected item if it's already selected

              if (_findInstanceProperty(newSelectedItems).call(newSelectedItems, function (prevItem) {
                return getItemId(prevItem) === getItemId(newSelectedItem);
              })) {
                newSelectedItems = _filterInstanceProperty(newSelectedItems).call(newSelectedItems, function (prevItem) {
                  return getItemId(prevItem) !== getItemId(newSelectedItem);
                });
              } else {
                var _context;

                // Add the new selected item into our state
                newSelectedItems = _concatInstanceProperty(_context = []).call(_context, _toConsumableArray(newSelectedItems), [newSelectedItem]);
              }

              newChanges = _objectSpread(_objectSpread({}, newChanges), {}, {
                inputValue: inputValue,
                // Continue to be in whatever state the menu
                // was in when the value was changed
                isOpen: state.isOpen,
                highlightedIndex: highlightedIndex,
                selectedItems: newSelectedItems
              });
            } else {
              newChanges = _objectSpread(_objectSpread({}, newChanges), {}, {
                // Close the menu when we select an item in a single select
                // (this is default behaviour except for the 'FunctionSelectItem)
                isOpen: false,
                selectedItems: [newSelectedItem]
              });
            }
          }

          break;

        case useCombobox.stateChangeTypes.InputBlur:
          if (multi) {
            newChanges = _objectSpread(_objectSpread({}, newChanges), {}, {
              inputValue: ''
            });
          } else {
            // When blurring the input, set the input value back to the
            // selected item string for single selects
            newChanges = _objectSpread(_objectSpread({}, newChanges), {}, {
              selectedItem: newSelectedItem,
              inputValue: itemToString(newSelectedItem)
            });
          }

          break;

        case useCombobox.stateChangeTypes.FunctionReset:
          newChanges = _objectSpread(_objectSpread({}, newChanges), {}, {
            isOpen: isOpen,
            selectedItems: []
          });
          break;

        default:
          break;
      }

      return stateReducer(state, _objectSpread(_objectSpread({}, helpers), {}, {
        changes: newChanges
      }));
    }, [multi, initialSelectedItems, getItemId, itemToString, stateReducer]),
    onStateChange: useCallback(function (changes) {
      var type = changes.type,
          inputValue = changes.inputValue,
          highlightedIndex = changes.highlightedIndex,
          selectedItem = changes.selectedItem,
          selectedItems = changes.selectedItems;

      switch (type) {
        // We only want the items to be filtered as the user
        // is typing so we only update it here
        case useCombobox.stateChangeTypes.FunctionSetInputValue:
        case useCombobox.stateChangeTypes.InputChange:
          setFilterInputValue(inputValue);
          break;
        // For all actions where the user is performing an action
        // unrelated to changing the input that would otherwise
        // trigger an input change internally, we instead
        // reset the filter so our items go back to being unfiltered
        // if there are no items being shown to the user

        case useCombobox.stateChangeTypes.FunctionOpenMenu:
        case useCombobox.stateChangeTypes.ControlledPropUpdatedSelectedItem:
        case useCombobox.stateChangeTypes.FunctionCloseMenu:
        case useCombobox.stateChangeTypes.FunctionReset:
        case useCombobox.stateChangeTypes.FunctionSelectItem:
        case useCombobox.stateChangeTypes.FunctionToggleMenu:
        case useCombobox.stateChangeTypes.InputBlur:
        case useCombobox.stateChangeTypes.InputKeyDownEnter:
        case useCombobox.stateChangeTypes.InputKeyDownEscape:
        case useCombobox.stateChangeTypes.ItemClick:
        case useCombobox.stateChangeTypes.ToggleButtonClick:
          if (numItems <= 0) {
            setFilterInputValue('');
          }

          break;

        case useCombobox.stateChangeTypes.InputKeyDownArrowUp:
        case useCombobox.stateChangeTypes.InputKeyDownArrowDown:
          if (highlightedIndex >= 0) {
            scrollToIndex(highlightedIndex);
          }

          break;

        default:
          break;
      }

      if (changes.hasOwnProperty('selectedItem')) {
        if (!multi) {
          var _itemMap$get;

          var denormalisedSelectedItem = selectedItem ? (_itemMap$get = itemMap.get(getItemId(selectedItem))) === null || _itemMap$get === void 0 ? void 0 : _itemMap$get.item : null; // When it changes, send the selected value to the form

          onChange === null || onChange === void 0 ? void 0 : onChange(createFakeEvent(denormalisedSelectedItem));
          onBlur === null || onBlur === void 0 ? void 0 : onBlur(createFakeEvent(denormalisedSelectedItem));
        }
      }

      if (changes.hasOwnProperty('selectedItems')) {
        setSelectedItems(selectedItems);

        if (multi) {
          var _context2;

          var denormalisedSelectedItems = _filterInstanceProperty(_context2 = _mapInstanceProperty(selectedItems).call(selectedItems, function (item) {
            var _itemMap$get2;

            return (_itemMap$get2 = itemMap.get(getItemId(item))) === null || _itemMap$get2 === void 0 ? void 0 : _itemMap$get2.item;
          })).call(_context2, Boolean);

          onChange === null || onChange === void 0 ? void 0 : onChange(createFakeEvent(denormalisedSelectedItems));
          onBlur === null || onBlur === void 0 ? void 0 : onBlur(createFakeEvent(denormalisedSelectedItems));
        }
      }

      onStateChange === null || onStateChange === void 0 ? void 0 : onStateChange(changes);
    }, [multi, itemMap, numItems, getItemId, onChange, onBlur, setSelectedItems, onStateChange, setFilterInputValue, scrollToIndex])
  };
}